/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */
import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class ParentErrorStateMatcher implements ErrorStateMatcher {
	private lookUpParent: boolean = false;

	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
		const isSubmitted = form?.submitted;

		const controlDirtyOrTouched = control?.dirty || control?.touched;
		const controlInvalid = control?.invalid;
		const parentInvalid = control?.parent.invalid;

		return (controlDirtyOrTouched || isSubmitted) && (controlInvalid || (this.lookUpParent && parentInvalid));
	}

	/**
	 * @param lookUpParent If true, will look up the parent control for errors.
	 * If false, will only look at the current control.
	 */
	constructor(lookUpParent: boolean = false) {
		this.lookUpParent = lookUpParent;
	}
}
